export enum Page {
  HELP,
  PROFILE,
  DOCUMENTS,
  SETTINGS,
}
